<template>
  <div>
    <div v-if="showLogin">
      <v-card width="400" class="mx-auto mt-5">
        <v-card-title>
          <h1 class="primary--text display-1">Login</h1>
          <v-spacer></v-spacer>
          <h6 color="red" class="display-6 red--text">{{errMessage}}</h6>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field label="User E-mail" type="email" 
              v-model="lEmail" prepend-icon="mdi-account-circle"
            />
            <v-text-field 
              :type="showPassword ? 'text' : 'password'" 
              label="Password" v-model="lPassword"
              prepend-icon="mdi-lock" 
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="userLogin"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="showLogin=false">
            Sign-Up
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text x-small color="error" @click.stop="modal = true">Forgot Password</v-btn>
          <v-dialog v-model="modal" max-width="320">
            <v-card>
              <v-card-title class="primary--text headline">Reset Password</v-card-title>
              <v-card-text>
                <v-form>
                  <v-text-field label="User E-mail" type="email"
                    v-model="lEmail" 
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="resetPwd" text>Reset Pwd</v-btn>
                <v-btn color="success" @click="modal=false" text>Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="userLogin">Login</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div v-else>
      <v-card width="400" class="mx-auto mt-5">
        <v-card-title>
          <h1 class="primary--text display-1">Sign-Up</h1>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field label="E-mail" v-model="sEmail" prepend-icon="mdi-account-circle" />
            <v-text-field label="First Name" v-model="sFName" prepend-icon="mdi-alpha-f-circle" />
            <v-text-field label="Last Name" v-model="sLName" prepend-icon="mdi-alpha-l-circle" />
            <v-text-field 
              :type="showPassword ? 'text' : 'password'" 
              label="Password"
              v-model="sPassword"
              prepend-icon="mdi-lock" 
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showSPassword = !showSPassword"
            />
            <v-text-field 
              :type="showPassword ? 'text' : 'password'" 
              label="Confirm Password"
              v-model="cPassword"
              prepend-icon="mdi-lock" 
              :append-icon="showCPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showCPassword = !showCPassword"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="showLogin=true">Back to Login</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="userSignup" class="white--text">Sign-Up</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'login',
  computed: {
    ...mapGetters([
      'errMessage'
    ])
  },
  data: () => ({
    showPassword: false,
    showSPassword: false,
    showCPassword: false,
    showLogin: true,
    lEmail: "",
    lPassword: "",
    sEmail: "",
    sPassword: "",
    cPassword: "",
    sFName: "",
    sLName: "",
    modal: false,
  }),
  methods: {
    userLogin() {
      const data = {
        userEmail: this.lEmail,
        userPassword: this.lPassword
      }
      this.$store.dispatch('userLogin', data)
      .then(() => {
        if (this.errMessage == '') {
          this.lEmail = ''
        }
        this.lPassword = ''
        //this.$router.push('/')
      })
    },
    userSignup() {
      if (this.cPassword !== this.sPassword) {
        this.cPassword = ""
        this.sPassword = ""
        return alert("Confirm Password is not the same as Password")
      }
      let data = {
        userEmail: this.sEmail,
        userFName: this.sFName,
        userLName: this.sLName,
        userPassword: this.sPassword, 
      }
      this.$store.dispatch('createUser', data)
      .then(() => {
        if (this.errMessage !== "") {
          return alert(this.errMessage)
        }
        this.sFName = ''
        this.sLName = ''
        this.sEmail = ''
        this.sPassword = ''
        this.cPassword = ''
        alert("A mail has been sent to you.  Please follow the instructions on that mail")
      })
    },
    resetPwd() {
      this.lEmail.trim()
      if (this.lEmail == "") {
        alert("Please enter User E-mail")
        return
      }
      const data = { userEmail: this.lEmail }
      const header = { 'Content-Type': 'application/json' }
      axios.post('/api/resetpwd', JSON.stringify(data), { headers: header })
      .then(function() {
        alert('A mail has been sent to you.  Please follow the instructions in that mail')
      })
      .catch(function(error) {
        alert(error.response.data.err)
      })
      this.modal = false
    }
  }
}
</script>